import DefaultAddImplementingOfficer from "src/components/feature/AddImplementingOfficer";

const AddImplementingOfficer = () => {
  return <DefaultAddImplementingOfficer />;
};

export default AddImplementingOfficer;
